module.exports = __webpack_public_path__ + "img/5.d01c8547.jpg";